import React from "react";
import { Info, Mail, LogIn, UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import RightSidebar from "../../../sidebar/RightSideBar";
import { useBase } from "../../../../store/useBase";
import PhoneInput from "../../../PhoneInput";

const InquirySidebarForm = ({
  isOpen,
  onClose,
  data,
  onChange,
  onSubmit,
  siteUser,
}) => {
  const navigate = useNavigate();
  const { siteSlug } = useBase();

  if (!siteUser) {
    return (
      <RightSidebar
        isOpen={isOpen}
        onClose={onClose}
        title="Inquiry"
        widthClass="sm:w-[450px]"
        contentPadding="p-0"
      >
        <div className="flex flex-col items-center justify-center h-full px-8 py-10 text-center gap-8">
          <div className="space-y-4">
            <div className="w-16 h-16 bg-slate-50 rounded-3xl flex items-center justify-center text-slate-300 mx-auto border border-slate-100 shadow-inner">
              <Mail size={32} />
            </div>
            <h3 className="section-heading">
              Please register and sign in to the website to take part in the
              event
            </h3>
          </div>

          <div className="flex flex-col w-full gap-4 max-w-[280px]">
            <button
              onClick={() =>
                navigate(
                  `/${siteSlug}/signin`,
                )
              }
              className="form-primary-btn justify-center"
            >
              Sign In
            </button>

            {/* <div className="flex items-center gap-4">
              <div className="h-px bg-slate-600 flex-1"></div>
              <span className="text-[10px] font-black text-slate-600 uppercase tracking-widest">
                OR
              </span>
              <div className="h-px bg-slate-600 flex-1"></div>
            </div>

            <button
              onClick={() => navigate(`/${siteSlug}/signin`)}
              className="form-cancel-btn justify-center"
            >
              Register Now
            </button> */}
          </div>
        </div>
      </RightSidebar>
    );
  }

  return (
    <RightSidebar
      isOpen={isOpen}
      onClose={onClose}
      title="Submit Inquiry"
      widthClass="sm:w-[500px] md:w-[600px]"
      contentPadding="p-0"
    >
      <div className="flex flex-col h-full px-4 py-1">
        <div className="flex-1 overflow-y-auto overflow-x-hidden space-y-4 md:px-2 no-scrollbar">
          {/* Info Box */}
          <div className="bg-blue-50 border border-blue-100 p-2 rounded-md flex gap-4">
            <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center text-white shrink-0 mt-0.5">
              <Info size={14} />
            </div>
            <p className="text-xs text-blue-900 font-medium leading-relaxed">
              On submitting this inquiry, your name, email, designation, and
              company information will be shared with the exhibitor.
            </p>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="form-label ml-1">
                  First Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={data.firstName}
                  onChange={onChange}
                  required
                  placeholder="e.g. Aditya"
                  className="form-input"
                />
              </div>
              <div className="space-y-2">
                <label className="form-label ml-1">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={data.lastName}
                  onChange={onChange}
                  placeholder="e.g. Deshmukh"
                  className="form-input"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="form-label ml-1">
                  Email<span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={data.email}
                  onChange={onChange}
                  required
                  placeholder="e.g. aditya@example.com"
                  className="form-input"
                />
              </div>
              <div className="space-y-2">
                <label className="form-label ml-1">Phone Number</label>
                <PhoneInput
                  country={"in"}
                  preferredCountries={["in"]}
                  enableSearch={true}
                  value={data.phone || ""}
                  onChange={(val) =>
                    onChange({ target: { name: "phone", value: val } })
                  }
                  containerClass="!w-full"
                  inputStyle={{
                    width: "100%",
                    height: "40px",
                    fontSize: "14px",
                    borderRadius: "8px",
                    borderColor: "#e5e7eb",
                    backgroundColor: "#f9fafb",
                  }}
                  buttonStyle={{
                    borderRadius: "8px 0 0 8px",
                    borderColor: "#e5e7eb",
                    backgroundColor: "#f9fafb",
                  }}
                  dropdownStyle={{
                    width: "280px",
                    borderRadius: "12px",
                    marginTop: "2px",
                    boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
                  }}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="form-label ml-1">Designation</label>
                <input
                  type="text"
                  name="designation"
                  value={data.designation}
                  onChange={onChange}
                  className="form-input"
                />
              </div>
              <div className="space-y-2">
                <label className="form-label ml-1">Organization</label>
                <input
                  type="text"
                  name="organization"
                  value={data.organization}
                  onChange={onChange}
                  className="form-input"
                />
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between ml-1">
                <label className="form-label">
                  Message<span className="text-red-500">*</span>
                </label>
                <span className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                  {data.message.length}/1000
                </span>
              </div>
              <textarea
                name="message"
                value={data.message}
                onChange={onChange}
                required
                maxLength={1000}
                className="form-input h-40 py-2"
              />
            </div>
          </form>
        </div>

        <div className="p-2 border-t border-slate-100 bg-slate-50/50 flex items-center justify-between gap-3">
          <button type="button" onClick={onClose} className="form-cancel-btn">
            Cancel
          </button>
          <button onClick={onSubmit} className="site-color-btn">
            Submit Inquiry
          </button>
        </div>
      </div>
    </RightSidebar>
  );
};

export default InquirySidebarForm;
